import React, { useState, useEffect } from 'react';

import { FlexDiv, GenericSpan, GenericP } from 'commonStyles';
import { Item, OptionWrapper } from './BottomFilterStyles';

const BottomElement = ({ field = {}, value, handleSelection }) => {
	const { label, key, options } = field;

	field.value = field.options.filter((opt) => opt.value === value)[0];
	const [activeValue, setActive] = useState(value);

	useEffect(() => {
		setActive(value);
	}, [value]);

	const handleChange = (data = {}) => () => {
		field.value = data;
		setActive(data.value);
		handleSelection(key, data.value);
	};

	return (
		<FlexDiv key={key} directionInMobile='column'>
			<GenericP>{label}</GenericP>
			<OptionWrapper justify='flex-start'>
				{options && options.map((opt) => {
					const { mobileLabel, label, value: valueKey = '', subLabel } = opt;

					const title = mobileLabel || label;
					const isActive = activeValue === valueKey;
					return (
						<Item
							directionInMobile='column'
							align='center'
							onClick={handleChange(opt)}
							key={valueKey}
							className={`${key !== 'destinationType' ? 'over' : 'up'} ${isActive ? 'active' : 'inactive'}`}>
							{title && <GenericSpan color={`${isActive ? '#FFF' : ''}`} f_weight='700'>{title}</GenericSpan>}
							{subLabel && <GenericSpan color={`${isActive ? '#FFF' : ''}`} fsize='12px'>{subLabel}</GenericSpan>}
						</Item>
					);
				})}
			</OptionWrapper>
		</FlexDiv>
	);
};

export default React.memo(BottomElement);
